import React from 'react';
var SnippylyHuddleTool = function (props) {
    var type = props.type;
    return (React.createElement("velt-huddle-tool", { type: type }));
};
export default SnippylyHuddleTool;
